// 레퍼런스 검색은 별도 배포 단위(deploy/reference_search)라 base URL 이 다르다. cs-rag 와 같은 패턴.
import { getAuthIdToken } from "@/lib/firebase";
import axios from "axios";

const referenceSearchInstance = axios.create({
  baseURL: `${import.meta.env.VITE_REFERENCE_SEARCH_API_URL}`,
  timeout: 120_000,
  headers: { "Content-Type": "application/json" },
});

referenceSearchInstance.interceptors.request.use(async (config) => {
  const idToken = await getAuthIdToken();
  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});

export default referenceSearchInstance;
